module.exports = __webpack_public_path__ + "static/media/point_yellow.2b636cc9.svg";